import { Box, Button, Flex, HStack, Text, useToast } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { RiArrowLeftLine } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch, useTypedSelector } from "store/hooks";
import { cadastrarAnimal } from "store/modules/zoonose/actions/cadastrarAnimal";
import { uploadFotosAnimal } from "store/modules/zoonose/fotos/actions/uploadFotosAnimal";
import { toNumberOrNull } from "utils/to-number-or-null";
import { FormAnimal } from "../components/FormAnimal";
import {
  formAnimalSchema,
  FormAnimalValues
} from "../components/FormAnimal/types";

const CreateAnimal = () => {
  const [idResponse, setIdResponse] = useState<string>();
  const [filesToUpload, setFilesToUpload] = useState<File[]>([]);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const toast = useToast();

  const methods = useForm<FormAnimalValues>({
    resolver: yupResolver(formAnimalSchema)
  });
  const handleSubmit = methods.handleSubmit;

  const { successPayload: doencas } = useTypedSelector(
    (state) => state.zoonose.obterDoencas
  );

  const { isRequesting } = useTypedSelector(
    (state) => state.zoonose.cadastrarAnimal
  );

  useEffect(() => {
    if (doencas?.length > 0) {
      methods.setValue("doencasPreexistentes", [String(doencas[0].value)]);
    }
  }, [doencas]);

  const onSubmit: SubmitHandler<FormAnimalValues> = (data) => {
    const peso = data?.peso ? data.peso.toString().replace(".", ",") : "";
    dispatch(
      cadastrarAnimal({
        ...data,
        peso: Number(peso),
        idadeAnos: toNumberOrNull(data.idadeAnos),
        idadeMeses: toNumberOrNull(data.idadeMeses),
        castrado: data.castrado === "true",
        desejaCastrar: data.desejaCastrar === "true",
        vacinaEmDia: data.vacinaEmDia === "true",
        desejaVacinar: data.desejaVacinar === "true",
        dataUltimaVacinacao: data.dataUltimaVacinacao || null,
        dataObito: data.dataObito || null,
        onSuccess: (id) => {
          setIdResponse(id);
          toast({
            title: "Cadastro realizado com sucesso",
            status: "success",
            duration: 2000
          });
          if (filesToUpload.length > 0) {
            dispatch(
              uploadFotosAnimal({
                idAnimal: id,
                fotos: filesToUpload,
                onSuccess: () => {
                  navigate("/zoonose");
                }
              })
            );
          } else {
            navigate("/zoonose");
          }
        }
      })
    );
  };

  return (
    <FormProvider {...methods}>
      <Flex justifyContent="center" alignItems="center">
        <Box
          w="full"
          maxW="container.xl"
          h="full"
          py={{ base: 8 }}
          px={{ base: 6, sm: 8, xl: 16 }}
          overflowY="visible"
          overflowX="visible"
        >
          <Link to={"/zoonose"}>
            <Button colorScheme="gray" color="gray.900" variant="link" gap={2}>
              <RiArrowLeftLine /> Voltar
            </Button>
          </Link>
          <Text as="h3">Cadastrar novo pet</Text>

          <Box as="form" onSubmit={handleSubmit(onSubmit)}>
            <FormAnimal
              idAnimal={idResponse}
              onFilesSelected={setFilesToUpload}
            />

            <HStack w="full" mt={5} justifyContent="flex-end">
              <Button
                colorScheme="green"
                variant="outline"
                isDisabled={isRequesting}
                onClick={() => navigate("/zoonose")}
              >
                Cancelar
              </Button>
              <Button
                type="submit"
                colorScheme="green"
                isLoading={isRequesting}
              >
                Cadastrar Animal
              </Button>
            </HStack>
          </Box>
        </Box>
      </Flex>
    </FormProvider>
  );
};

export default CreateAnimal;
